"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PageAnalyticsController_1 = __importDefault(require("./PageAnalyticsController"));
var EmptyAnalyticsController = /** @class */ (function (_super) {
    __extends(EmptyAnalyticsController, _super);
    function EmptyAnalyticsController(datalayerManager) {
        return _super.call(this, 'Vehicle Summary component', datalayerManager) || this;
    }
    EmptyAnalyticsController.prototype.track = function () {
        //do nothing
    };
    return EmptyAnalyticsController;
}(PageAnalyticsController_1.default));
exports.default = EmptyAnalyticsController;
